import { getDateTimeFormatter } from '@fe/core';
import { GDFHotPolyHiRecordNormal } from '../../../gdf/type';

export default function HotPolySuaTooltip({ record }: { record: GDFHotPolyHiRecordNormal }) {
    const formatter = getDateTimeFormatter();
    return (
        <div>
            <div style={{ display: 'grid', gridTemplateColumns: 'max-content auto', columnGap: '1rem' }}>
                <div>ID:</div>
                <div>{record.label}</div>
                <div>Type:</div>
                <div>{typesLabels[record.speed ?? -1] ?? 'N/A'}</div> {/* Hijacked speed field... */}
                <div>Start:</div>
                <div>{formatter.formatDateTime(record.startTime)}</div>
                <div>End:</div>
                <div>{formatter.formatDateTime(record.endTime)}</div>
                <div>Base:</div>
                <div>{topBaseToString(record.suaBase)}</div>
                <div>Top:</div>
                <div>{topBaseToString(record.suaTop)}</div>
                <div>Issued:</div>
                <div>{formatter.formatDateTime(record.issuedTime)}</div>
            </div>
            <div style={{ whiteSpace: 'pre' }}>{record.detail}</div>
        </div>
    );
}

function topBaseToString(input: number | null): string {
    if (input === null) {
        return '-';
    }

    if (input === 0) {
        return 'Sfc';
    }

    if (input === 0xfffe) {
        return 'Unl;';
    }
    return `FL${input.toString().padStart(3, '0')}`;
}

const typesLabels: Partial<Record<number, string>> = {
    [0]: 'Military operating area',
    [1]: 'Prohibited area',
    [2]: 'Restricted area',
    [3]: 'Alert area',
    [4]: 'Warning area',
    [5]: 'Caution area',
    [6]: 'Danger area',
    [7]: 'Training',
    [8]: 'Other',
    [9]: 'Training area'
};
